import React from 'react';
import { Row, Column } from '@upgrade/react-components';

import { Section, MainTitle } from '../common/styles';
import { AboutHero, TitleLight, OurGoalContainer } from './styles';
import ContactInfo from '../common/ContactInfo';

import Fluid from '../Fluid';

import FeaturesSection from '../common/FeaturesSection';
import WhyChooseUs from '../common/WhyChooseUsSection';
import PoweredByUpgrade from './powered-by-upgrade';

const AboutComponent = ({ missionHero, whyChooseUs, features, poweredByUpgrade, contact }) => (
  <>
    {missionHero && (
      <Section data-color={missionHero.backgroundColor} paddingBottom={0}>
        <Fluid>
          <Row>
            <Column xs={12}>
              <MainTitle>{missionHero.title}</MainTitle>
            </Column>
          </Row>
        </Fluid>
        <Row xsHorizontalAlign="center">
          <Column xs={12}>
            <AboutHero id="about-us-top">
              <OurGoalContainer>
                <TitleLight>{missionHero.missionTitle}</TitleLight>
                <p className="text--weight-light">{missionHero.missionText}</p>
              </OurGoalContainer>
            </AboutHero>
          </Column>
        </Row>
      </Section>
    )}
    {whyChooseUs && <WhyChooseUs {...whyChooseUs} />}
    {features && <FeaturesSection {...features} />}
    {poweredByUpgrade && <PoweredByUpgrade {...poweredByUpgrade} />}
    {contact && <ContactInfo contact={contact} />}
  </>
);

export default AboutComponent;
